<div class="modal fade" tabindex="-1" role="dialog" id="resultado-pa-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'pca.resultadoPCA.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
<!--      <div class="modal-body">-->
        <div class="container striped-rows">
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'pca.resultadoPCA.filtros.mercado'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="text" placeholder="Selecione o Mercado..."
                [(ngModel)]="Mercado">
                <option translate value="">{{'pca.resultadoPCA.filtros.mercadoPlaceHolder'}}</option>
                <option *ngFor="let item of mercado" [value]="item.id">{{item.descricao}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'pca.resultadoPCA.filtros.grupoEconomico'}}
            </div>
            <div class="col col-8" name="GrupoEconomico">
              <select class="form-control form-control-sm" type="text" (change)="selecionaDealer()" [(ngModel)]="GrupoEconomico"
                placeholder="Selecione o grupo econômico...">
                <option translate value="">{{'pca.resultadoPCA.filtros.grupoEconomicoPlaceHolder'}}</option>
                <option *ngFor="let item of gruposEconomicos" [value]="item.id"> {{item.descricao}} </option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'pca.resultadoPCA.filtros.regiao'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="number" placeholder="Selecione a Região..." [(ngModel)]="Regiao">
                <option translate value="">{{'pca.resultadoPCA.filtros.regiaoPlaceHolder'}}</option>
                <option *ngFor="let item of regioes" [value]="item.id">{{item.descricao}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              Dealer
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="number" [(ngModel)]="Dealer">
                <option translate value="">{{'pca.resultadoPCA.filtros.dealerPlaceHolder'}}</option>
                <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'pca.resultadoPCA.filtros.dataInicial'}}
            </div>
            <div class="col col-8">
                <div class="input-group input-group-sm ">
                    <input class="form-control" class="form-control" placeholder="{{'pca.resultadoPCA.filtros.dataInicialPlaceHolder' | translate}}" [(ngModel)]="InicialData" [(ngModel)]="dataInicial" 
                    [maxDate]="max" ngbDatepicker #dataInicialView="ngbDatepicker" (click)="dataInicialView.toggle()"> 
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" (click)="dataInicialView.toggle()" type="button">
                        <em class="fa fa-calendar"></em>
                  </button>
                </div>
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" (click)="limparDataInicial(dataInicialView)" type="button">
                    <em class="fa fa-trash"></em>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'pca.resultadoPCA.filtros.dataFinal'}}
            </div>
            <div class="col col-8">
                <div class="input-group input-group-sm ">
                    <input class="form-control" class="form-control" placeholder="{{'pca.resultadoPCA.filtros.dataFinalPlaceHolder' | translate}}" [(ngModel)]="FinalData" [(ngModel)]="dataFinal" 
                    [maxDate]="max" ngbDatepicker #dataFinalView="ngbDatepicker" (click)="dataFinalView.toggle()">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" (click)="dataFinalView.toggle()" type="button">
                        <em class="fa fa-calendar"></em>
                  </button>
                </div>
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" (click)="limparDataFinal(dataFinalView)" type="button">
                    <em class="fa fa-trash"></em>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--      </div>-->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary"
          (click)="Mercado() || GrupoEconomico() || Regiao() || Dealer() || limparDataInicial(dataInicialView) || limparDataFinal(dataFinalView)">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>